import { RouteName } from "../RouteNames";

export const dashboardsRoutes = {
  name: RouteName.Dashboard,
  path: "/dashboards",
  component: () => import("@follaw-fr/views/top_menu_views/DashboardsView.vue"),
};
